import ReactSVG from "react-svg"
import ArrowLeft from "../../../images/go_back_icon_white.svg"
import { connect } from "react-redux"
import { fetchClosedOrderDetails } from "../../actions/user"
import { withRouter } from "react-router"
import { Button } from "semantic-ui-react"
import ReceiptPrintPreview from "./ReceiptPrintPreview"
import { useEffect, useState } from "react"
import CircularLoader from "../../../shared_component/components/CircularLoader"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faArrowDownToBracket } from "@fortawesome/pro-solid-svg-icons"
import { CREDIT_CARD_TYPE } from "caradvise_shared_components/lib/constants/payment_providers"
import { PAYPAL } from "../../constants/tires"
import { numberFormatToCurrency } from "../../../shared_component/utils/currency"

const ViewReceipt = ({ match, fetchClosedOrderDetails, user, history }) => {
  const { id } = match?.params
  const [order, setOrder] = useState(null)
  const [error, setError] = useState(false)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    setLoading(true)
    try {
      fetchClosedOrderDetails(user.id, id, (data) => {
        if (data.result) {
          setOrder(data.result)
        } else {
          setError(true)
        }
        setLoading(false)
      })
    } catch (e) {
      setLoading(false)
    }
  }, [])

  const [showPrintPreview, setShowPrintPreview] = useState(false)

  const vehicle = order?.vehicle || {}
  const shop = order?.shop || {}
  const paymentMethod = order?.braintree_payment_methods?.[0] || {}

  return (
    <div className="view-receipt service-request">
      <div className="service-request-header">
        <div className="header-content">
          <div className="back-button" onClick={() => history.goBack()}>
            <ReactSVG src={ArrowLeft} />
            <p>Back</p>
          </div>
        </div>
      </div>

      {(loading || error) && (
        <div className="loader-wrapper">
          <div className="card card-sm-gap">
            {loading ? <CircularLoader /> : <p>Failed to load order</p>}
          </div>
        </div>
      )}

      {order?.id && (
        <div className="content-wrapper">
          {/* Transaction */}
          <div className="card card-sm-gap">
            <div className="row">
              <p className="text-label">Transaction date</p>
              <p className="text-value">{monthDateFormat(order.appointment_datetime)}</p>
            </div>
            <div className="row">
              <p className="text-label">Shop Order ID</p>
              <p className="text-value">{order.id}</p>
            </div>
          </div>

          {/* Vehicle */}
          <div className="card card-md-gap">
            <p className="section-title">Vehicle</p>

            <div className="row">
              <p className="text-label">Year / Make / Model</p>
              <p className="text-value">
                {vehicle.year} {vehicle.make} {vehicle.model}
              </p>
            </div>

            <div className="row">
              <p className="text-label">Mileage</p>
              <p className="text-value">{vehicle?.odometer_config?.display_value_abbr}</p>
            </div>
          </div>

          {/* Shop */}
          <div className="card card-md-gap">
            <p className="section-title">Shop</p>

            <div className="row-start">
              <p className="text-value">{shop.name}</p>
              <p className="text-label">{shop.address_line1}</p>
              <p className="text-label">
                {shop.city}, {shop.state} {shop.zip}
              </p>
              <p className="text-label">{shop.main_phone_number}</p>
            </div>
          </div>

          {/* Services */}
          <div className="card card-md-gap">
            <p className="section-title">Services completed</p>

            <div className="row divider">
              <p className="text-label">Description</p>
              <p className="text-label">Amount</p>
            </div>

            {order.order_services?.map((service, index) => (
              <div className="service-row" key={index}>
                <p className="name">
                  {service.name} {service.position ? `(${service.position})` : ""}
                </p>
                <p className="amount">
                  {numberFormatToCurrency(Number(service.override_total || 0).toFixed(2))}
                </p>
              </div>
            ))}
          </div>

          {/* Pricing */}
          <div className="card card-lg-gap">
            <div className="flex-column card-md-gap">
              {Number(order.membership_discount) ? (
                <div className="row">
                  <p className="text-label">Premium Membership Discount</p>
                  <p className="text-value">
                    -{numberFormatToCurrency(Number(order.membership_discount).toFixed(2))}
                  </p>
                </div>
              ) : null}

              <div className="row">
                <p className="text-label">Subtotal</p>
                <p className="text-value">
                  {numberFormatToCurrency(Number(order.estimated_sub_total || 0).toFixed(2))}
                </p>
              </div>

              {Number(order?.applicable_surcharge_percent) ? (
                <div className="row">
                  <p className="text-label">Convenience Network Surcharge</p>
                  <p className="text-value">{Math.round(order.applicable_surcharge_percent)}%</p>
                </div>
              ) : null}

              <div className="row">
                <p className="text-label">Transaction Fee</p>
                <p className="text-value">
                  {numberFormatToCurrency(Number(order.transaction_fee || 0).toFixed(2))}
                </p>
              </div>

              <div className="row">
                <p className="text-label">Taxes</p>
                <p className="text-value">
                  {numberFormatToCurrency(Number(order.tax_amount || 0).toFixed(2))}
                </p>
              </div>

              <div className="total-row">
                <p>Total paid</p>
                <p>{numberFormatToCurrency(Number(order.estimated_total || 0).toFixed(2))}</p>
              </div>
            </div>

            <div className="savings">
              <p>Total Saved with CarAdvise</p>
              <p>{numberFormatToCurrency(Number(order.estimated_savings || 0).toFixed(2))}</p>
            </div>
          </div>

          {/* Payment */}
          {paymentMethod.type && (
            <div className="card card-md-gap">
              <p className="section-title">Payment type</p>
              {paymentMethod.type === CREDIT_CARD_TYPE && (
                <p className="text-label text-start">
                  {paymentMethod.card_type}****{paymentMethod.last_4}
                </p>
              )}
              {paymentMethod.type === PAYPAL && (
                <p className="text-label text-start">PayPal {paymentMethod.email}</p>
              )}
            </div>
          )}

          {/* Download */}
          <Button onClick={() => setShowPrintPreview(true)} className="download-btn">
            <div className="btn-content">
              <FontAwesomeIcon icon={faArrowDownToBracket} color="#FFF" />
              <p>Download PDF</p>
            </div>
          </Button>

          <p className="footer-text">
            Shop-issued receipts may not display your CarAdvise pricing or applied discounts. Use
            this receipt as your official proof of payment.
          </p>
        </div>
      )}

      {order && (
        <ReceiptPrintPreview
          order={order}
          open={showPrintPreview}
          close={() => setShowPrintPreview(false)}
        />
      )}
    </div>
  )
}

// March 17, 2026
export const monthDateFormat = (date) =>
  new Date(date).toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric"
  })

function mapStateToProps(state, props) {
  let user = state.user || {}

  return {
    user
  }
}

export default connect(mapStateToProps, { fetchClosedOrderDetails })(withRouter(ViewReceipt))
